export default __webpack_public_path__ + "static/media/structuring.3de679ff.svg";